import React, { Component } from "react";
import { connect } from "react-redux";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { authority, clientId, redirectUri } from "../../AuthConfig";
import { PublicClientApplication } from "@azure/msal-browser";

class ProfileMini extends Component {
  constructor(props) {
    super(props);

    this.msalConfig = {
      auth: {
        clientId: clientId,
        redirectUri: redirectUri,
        authority: authority,
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    };

    this.msalInstance = new PublicClientApplication(this.msalConfig);
  }
  // recent logout = () => {
  //   const accounts = this.msalInstance.getAllAccounts();

  //   const logoutRequest = {
  //     account: accounts[0],
  //     postLogoutRedirectUri: redirectUri,
  //     authority: authority,
  //   };
  //   this.msalInstance.logoutRedirect(logoutRequest);
  //   localStorage.removeItem("loginCount");
  //   this.props.dispatch({ type: "Referenceno", value: "" });
  //   this.props.dispatch({ type: "UserId", value: "" });
  //   this.props.dispatch({ type: "profile", value: "" });
  //   this.props.dispatch({ type: "headerTitle", value: "" });
  //   this.props.dispatch({ type: "Token", value: "" });
  //   this.props.dispatch({ type: "userType", value: "" });
  //   this.props.dispatch({ type: "userName", value: "" });
  //   sessionStorage.removeItem("EnableGoodsExitDate");
  //   sessionStorage.clear();
  // };
  // old logout = () => {
  //   this.props.dispatch({ type: "Referenceno", value: "" });
  //   this.props.dispatch({ type: "UserId", value: "" });
  //   this.props.dispatch({ type: "profile", value: "" });
  //   this.props.dispatch({ type: "headerTitle", value: "" });
  //   this.props.dispatch({ type: "Token", value: "" });
  //   this.props.dispatch({ type: "userType", value: "" });
  //   this.props.dispatch({ type: "userName", value: "" });
  //   sessionStorage.removeItem("EnableGoodsExitDate");
  //   sessionStorage.clear();
  // };
  // new flow
  logout = () => {
    const accounts = this.msalInstance.getAllAccounts();

    if (accounts.length > 0) {
      this.msalInstance.setActiveAccount(null);
    }

    localStorage.clear();
    sessionStorage.clear();

    this.props.dispatch({ type: "UserId", value: "" });
    this.props.dispatch({ type: "Token", value: "" });
    this.props.dispatch({ type: "userName", value: "" });
    this.props.dispatch({ type: "userType", value: "" });

    window.location.href = "/login";
  };

  render() {
    return (
      <>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="navbar-nav ml-auto">
            <NavDropdown
              title={
                <button id="navbardrop" className="button-link">
                  <span className="d-inline-block">
                    {" "}
                    {this.props.userName}{" "}
                    <span className="f-s-12 f-w-300">
                      {" "}
                      ({this.props.userType}){" "}
                    </span>{" "}
                  </span>
                </button>
              }
              id="basic-nav-dropdown">
              <NavDropdown.Item href="#" className="dropdown-item">
                About me
              </NavDropdown.Item>
              <NavDropdown.Item
                href="#"
                className="dropdown-item"
                onClick={this.logout}>
                Sign in as different user
              </NavDropdown.Item>
              <NavDropdown.Item
                href="#"
                className="dropdown-item"
                onClick={this.logout}>
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(ProfileMini);

